'use client';
import { useMountEffect } from '@/hooks/useMountEffect';
import { classes } from './utils';

export default function NotFound() {
  useMountEffect(() => {
    // @ts-ignore
    window.location = '/dashboard/overview';
  });

  return <div className={classes.notFound}>Redirecting...</div>;
}
